export default __webpack_public_path__ + "static/media/WhitneySSm-Black-Adv_Web.83dc1e32.woff";